import React, { useEffect, useState } from "react";
import { X, Users, Globe, Leaf,LogOut } from "lucide-react";
import { Link } from "react-router-dom";

export default function Sidebar({ isOpen, onClose }) {
  const [userRole, setUserRole] = useState("");
  const [username, setUsername] = useState("");

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      const uname = localStorage.getItem("username");
      if (userData && userData.user_role) {
        setUserRole(userData.user_role.toLowerCase());
      }
      if (uname) setUsername(uname);
    } catch (error) {
      console.error("Error parsing user data from localStorage", error);
    }
  }, []);

  // Menus
  const adminMenu = [
    {
      label: "User Details",
      link: "/user-details",
      icon: <Users className="w-5 h-5 text-[#169C83]" />,
    },
    {
      label: "Web Scraper",
      link: "/webscraping",
      icon: <Globe className="w-5 h-5 text-[#169C83]" />,
    },
    {
      label: "Environment Data",
      link: "/environment-data",
      icon: <Leaf className="w-5 h-5 text-[#169C83]" />,
    },
  ];

  const userMenu = [
    {
      label: "Environment Data",
      link: "/environment-data",
      icon: <Leaf className="w-5 h-5 text-[#169C83]" />,
    },
  ];

  const menuItems = userRole === "admin" ? adminMenu : userMenu;

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
    className={`min-w-[250px] w-[250px] fixed inset-y-0 left-0 z-50 bg-primary-light 
                flex flex-col justify-between transform transition-transform duration-300 ease-in-out 
                ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"} 
                overflow-hidden`}
  >
        {/* Logo Header */}
        <div>
          <div className="flex items-center justify-between p-6">
            <Link to="/">
              <img
                width="150"
                height="40"
                alt="CIEMS"
                src="/images/logo.png"
              />
            </Link>
            <button
              onClick={onClose}
              className="lg:hidden p-1 hover:bg-[#d4f0eb] rounded transition-colors"
              aria-label="Close sidebar"
            >
              <X className="w-6 h-6 text-teal-700" />
            </button>
          </div>

          {/* Menu List */}
          <nav className="p-4">
            <ul>
              {menuItems.map((item, idx) => (
                <li key={idx}>
                  <Link
                    to={item.link}
                    className="flex items-center gap-3 px-6 py-3 hover:bg-[#d4f0eb] text-teal-800 font-semibold rounded-lg transition-colors"
                  >
                    {item.icon}
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Footer - User Info */}
        <div className="p-6 flex items-center gap-3 border-t border-gray-200">
          <div className="flex-1 min-w-0">
            <div className="flex flex-col text-sm truncate">
              <span className="font-semibold break-words leading-tight">
                {username || "Unknown User"}
              </span>
              <span className="text-gray-500 capitalize break-words leading-tight">
                {userRole || "user"}
              </span>
            </div>
          </div>

          <button
    aria-label="Logout"
    title="Logout"
    className="ml-auto shrink-0 p-2 rounded transition-colors hover:bg-[#d4f0eb] flex items-center justify-center"
    onClick={() => {
      localStorage.clear();
      window.location.href = "/login";
    }}
  >
    <LogOut className="w-5 h-5 text-[#374b47]" />
  </button>
        </div>

      </aside>
    </>
  );
}
